export default "__VITE_ASSET__551b7beb__"